import React, {useEffect, useState} from 'react';
import './scss/process-add.scss';
import FullScreenLoader from './full-screen';
import StatusProp from './properties/status';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function ProcessAdd({setStatusMessage}: StatusProp): React.ReactElement {
    const [processType, setProcessType] = useState("");
    const [desc, setDesc] = useState('');
    const [blockChain, setBlockchain] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');

    function resetForm() {
        setProcessType('');
        setDesc('');
        setBlockchain('');
    }

    function validateForm() {

        if (!processType) {
            setErrorMessage('Please select process type');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (!blockChain) {
            setErrorMessage('Please select blockchain');
            setSetErrorClass('error mb-4');
            return false;
        }

        setSetErrorClass('hide');
        return true;
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            setIsLoading(true);
            SandraJsAPI.addProcess(processType, blockChain, desc)
                .then((res) => {
                    setIsLoading(false);
                    if (res.error) {
                        setStatusMessage('Unable to add process', StatusMessageTypeEnum.error);
                    } else
                        setStatusMessage('Process added successfully', StatusMessageTypeEnum.success);
                    window.scrollTo(0, 0);
                    resetForm();
                })
                .catch((reason) => {
                    setIsLoading(false);
                    setStatusMessage(reason, StatusMessageTypeEnum.error);
                    window.scrollTo(0, 0);
                    console.log(reason);
                });
        } else {
            window.scrollTo(0, 0);
        }
    };

    useEffect(() => {
    }, []);

    return (
        <div className="rounded process-add loading-wrapper">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <div className={errorClass}>{errorMessage}</div>
            <h4 className="pb-3">Add New Process</h4>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <div className="mb-2 ms-1 form-label fst-italic">Select type of process you want to create</div>
                    <select
                        aria-label="Select Process Type"
                        onChange={(e) => {
                            setProcessType(e.target.value);
                        }}
                        className="form-select"
                        value={processType}
                    >
                        <option value="">{"Select"}</option>
                        <option value="scanner">{"Raw Data Scanner"}</option>
                        <option value="canonize">{"Canonizer"}</option>
                        <option value="timestamp_daemon">{"Timestamp Daemon"}</option>
                        <option value="asset_daemon">{"Asset Create Daemon"}</option>
                    </select>
                </div>
                <div className="mb-3">
                    <div className="mb-2 ms-1 form-label fst-italic">Select blockchain</div>
                    <select
                        aria-label="Select"
                        onChange={(e) => setBlockchain(e.target.value)}
                        className="form-select"
                        value={blockChain}
                    >
                        <option value="">Select</option>
                        <option value="binance">Binance</option>
                        <option value="ethereum">Ethereum</option>
                        <option value="klaytn">Klaytn</option>
                        <option value="ordinal">Ordinal</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="desc" className="form-label">
                        <span className="fst-italic ms-1">Description</span>
                        <textarea
                            id="desc"
                            className="form-control"
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                        />
                    </label>
                </div>
                <button type="submit" className="btn btn-dark">Submit</button>
            </form>
        </div>
    );
}

export default ProcessAdd;
